import { concat, get, isEmpty, keys, map, pick, reduce } from 'lodash';
import { all, put } from 'redux-saga/effects';
import { createStandardAction, getType } from 'typesafe-actions';

import { ResourceLite } from '../resources/createResource';
import { EntityBase } from '../resources/types';

import fetchBulk, { sagaFetchBulk } from './fetchBulk';
import { PayloadApiSuccess } from './sagaApi';

export interface FetchLookupsPayload<E extends EntityBase> extends Pick<PayloadApiSuccess<E>, 'normalized' | 'meta'> {
  resource: Pick<ResourceLite<E>, 'key' | 'lookups'>;
}

const fetchLookups = createStandardAction('@lib/fetchLookups')<FetchLookupsPayload<any>>();

// saga
export function* sagaFetchLookups(action: ReturnType<typeof fetchLookups>): Generator {
  const {
    payload: {
      resource,
      normalized: { entities },
      meta = {},
    },
  } = action;

  // Skip if there are no lookups to fetch
  const lookups = pick(get(resource, 'lookups'), keys(meta.includeLookups));
  if (isEmpty(lookups)) {
    return;
  }

  const effects = reduce(
    lookups,
    (result: any[], lookupResource, attribute) => {
      const ids = map(entities[resource.key], attribute);
      const fetchBulkPayload = {
        resource: lookupResource as any,
        ids,
        meta: {
          includeLookups: get(meta.includeLookups, attribute),
          resolveLookups: meta.resolveLookups,
        },
      };
      const newEffect = meta.resolveLookups
        ? // TODO use putResolve instead of saga when `resolveLookups: true`
          sagaFetchBulk({ type: getType(fetchBulk.request), payload: fetchBulkPayload })
        : put(fetchBulk.request(fetchBulkPayload));
      return concat(result, newEffect);
    },
    [],
  );

  return yield all(effects);
}

export default fetchLookups;
